import { Box, BoxProps, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

const DeadlineLabel: FC<PropsWithChildren> = (props) => {
  return <span className=" text-[--c-text] bg-[--c-background2] px-3 py-1">{props.children}</span>;
};

type RecruitingAuditionProps = { box?: BoxProps } & {
  lpUrl: string;
  image: string;
  title: string;
  detail: string;
  end: Date;
  now: Date;
  year_round: string;
};

export const RecruitingAudition: FC<RecruitingAuditionProps> = (props) => {
  const { t: tRecruitingAuditions } = useTranslationWithLang('recruitingAuditions');

  const getDeadlineMessage = (date: number, endTime?: string) => {
    // 応募締め切り本日{{time}}まで
    if (date === 0 && endTime) {
      return `${tRecruitingAuditions('TU009_009', { time: endTime })}`;
    }
    // 締め切りまであと{{date}}日
    return `${tRecruitingAuditions('TU009_007', { date })}`;
  };

  const now = props.now;

  // 公開終了日時 - 現在日時 を求め、日数に変換
  const deadlineAtDate = Math.floor((props.end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  // MM/dd HH:mm形式の日付文字列を作成
  const formatDateWithTime = () => {
    const month = (props.end.getMonth() + 1).toString().padStart(2, '0');
    const day = props.end.getDate().toString().padStart(2, '0');
    const hours = props.end.getHours().toString().padStart(2, '0');
    const minutes = props.end.getMinutes().toString().padStart(2, '0');
    return tRecruitingAuditions('TU009_009', { month, day, hours, minutes });
  };

  // 1日以内の場合は多言語ファイルでフォーマット
  const getDeadlineDisplay = () => {
    if (deadlineAtDate <= 1) {
      return formatDateWithTime();
    }
    return getDeadlineMessage(deadlineAtDate);
  };

  return (
    <Box {...props.box}>
      <a
        href={props.lpUrl}
        aria-hidden="false"
        tabIndex={0}
        title={props.title}
        aria-label={props.title}
      >
        <img src={props.image} alt={props.title} width={800} height={600} title={props.title} />
      </a>
      <Typography component="h2" variant="h6" fontWeight={'bold'}>
        {props.title}
      </Typography>
      <Typography>{props.detail}</Typography>
      <div className="my-2">
        {props.year_round !== '1' && <DeadlineLabel>{getDeadlineDisplay()}</DeadlineLabel>}
      </div>
    </Box>
  );
};
